<template>
  <div class="not-join">
    <div class="join-top">
      <div class="join-top-left">
        <span class="join-top-left-icon">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-a-warring-tianchong3"></use>
          </svg>
        </span>

        <span class="join-top-left-text">You are not a member of this campaign</span>
      </div>
      <artmisads-button :isSquare="true" type="primary" class="join-top-right" @click="joinCampaign">Join
        Campaign</artmisads-button>
    </div>
    <div class="join-content">
      <CampaignInfoCard :item="item" />
    </div>
    <div class="join-table">
      <div class="campaign-info-header">Product Information</div>
      <div class="join-table-content">
        <artmisads-table :pagination="false" :columns="publisherColumns" :data-source="publisherRows"
          :loading="publisherListLoading" :scroll="{ x: 1180 }" class="publisher-table">
          <template #bodyCell="{ column, record, text }">
            <template v-if="column.key === 'product'">
              <div class="publisher-cell">
                <LogoImage :max-width="'95%'" :logo-url="record.imageUrl" :brand-name="record.productTitle" :width="40"
                  :height="40" :font-size="10" :border-radius="4" />
                <span class="publisher-name">{{ record.productTitle }}</span>
              </div>

            </template>
            <template v-if="column.key === 'deal'">
              <div class="deal-cell">
                <product-deals-column v-if="record.productDeals?.length" v-for="item in record.productDeals"
                  :record="item" :key="item.id" />

                <span v-if="!record.productDeals?.length" class="deal-empty">-</span>
              </div>
            </template>
            <template v-if="column.key === 'price'">
              <Price :record="record" />
            </template>
            <template v-if="column.key === 'attributionCommission'">
              {{ record.attributionCommission }}%
            </template>
          </template>
        </artmisads-table>
      </div>

    </div>
    <JoinUpload ref="joinUploadRef" :marketplace="item.marketplace" />
  </div>
</template>
<script setup>
import { message } from 'ant-design-vue'
import { ref, onMounted } from 'vue'
import { cpcCampaignsApi } from '~/server'
import { useRoute, useRouter } from 'vue-router'
import LogoImage from '@/components/LogoImage.vue'
import ProductDealsColumn from "~/components/productDealsColumn.vue"
import Price from "~/components/Price.vue"
import CampaignInfoCard from './CampaignInfoCard.vue'
import { COUNTRY_SITE_CODE_MAP } from '~/contants/common'
import { associateTagsApi } from '@/server/publisher/associateTags'
import JoinUpload from './joinUpload.vue'
const router = useRouter()
const joinUploadRef = ref(null)
const route = useRoute()
const campaignId = route.params.id
const item = ref({})
const publisherColumns = [
  {
    title: 'Product',
    dataIndex: 'product',
    key: 'product',
  },
  {
    title: 'Brand',
    dataIndex: 'brandName',
    key: 'brandName',
  },
  {
    title: 'Category',
    dataIndex: 'primaryCategory',
    key: 'primaryCategory',
  },
  {
    title: 'Deal',
    dataIndex: 'deal',
    key: 'deal',
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
  },
  {
    title: 'AttributionCommission',
    dataIndex: 'attributionCommission',
    key: 'attributionCommission',
  },
]
const publisherListLoading = ref(false)
const publisherRows = ref([])
const getCampaignDetail = async () => {
  publisherListLoading.value = true
  const { data } = await cpcCampaignsApi.preJoinDetail({ campaignId: campaignId })
  item.value = data
  publisherRows.value = data.promotedProducts
  publisherListLoading.value = false
}
const joinCampaign = async () => {
  const countryCode = COUNTRY_SITE_CODE_MAP[item.value.marketplace]
  let { success, data, error } = await associateTagsApi.getAssociateTagsByCountryCode({ countryCode: countryCode })
  if (success) {
    if (data?.storeId) {
      const { success, data, error } = await cpcCampaignsApi.joinCpcCampaign({ campaignId: campaignId })
      if (success) {
        message.success('Join campaign success')
        router.back()
      } else {
        message.error(error)
      }
    } else {
      joinUploadRef.value.open()
    }
  }

}
onMounted(async () => {
  await getCampaignDetail()

})
</script>
<style lang="less" scoped>
.deal-empty {
  color: #9ca3af;
}
.campaign-info-header {
  font-family: Sora;
  font-weight: 600;
  font-size: 20px;
  letter-spacing: 0.4px;
  padding: 16px;
  border-bottom: 1px solid rgba(232, 229, 237, 1);
}
.publisher-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.not-join {
  .join-top {
    background: var(--Brand-Primary_weaker, rgba(138, 100, 244, 0.14));
    border-radius: 12px;
    border: 2px solid rgba(138, 100, 244, 1);
    padding: 7px 12px;

    .join-top-left {
      display: flex;
      align-items: center;
      gap: 3px;

      .join-top-left-icon {
        display: flex;
        width: 20px;
        height: 20px;
        border-radius: 10px;
        box-shadow: 0 0 0 3px rgba(131, 92, 242, 0.3);
        justify-content: center;
        margin-right: 8px;

        svg {
          width: 22px;
          min-width: 22px;
          height: 22px;
          fill: rgba(131, 92, 242, 1);
          align-self: center;
          margin-left: 1px;
        }
      }

      .join-top-left-text {
        font-family: Sora;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 24px;
        letter-spacing: 0.5px;

      }
    }

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .join-content {
    margin-top: 12px;
  }

  .join-table {
    background: #fff;
    border: 1px solid #e8e5ed;
    border-radius: 10px;
    overflow: hidden;
    margin-top: 16px;

    .join-table-content {
      padding: 16px;
    }

    // min-width: 820px;
  }

}
</style>